export default __webpack_public_path__ + "static/media/Foto23.c25ab9fd.png";